/* eslint-disable no-unused-vars, no-restricted-globals, prefer-const, default-case */
export function calculatePromoCodes(formData, validatedPromoCodes) {
  const registeredProducts = processFormData(formData)
  const discountedProducts = []

  const memberProfiles = registeredProducts.map(r => r.memberProfile).filter(m => !!m)

  validatedPromoCodes.forEach(promoCode => {
    const { code, rule, products } = promoCode

    if (!code || !rule || !products) {
      return
    }

    const { id: codeId, assignedTo } = code
    const { id: ruleId, name, discountBy, amount = 0, percentage = 0, type } = rule

    const matchingMemberProfile = assignedTo && memberProfiles.includes(assignedTo) ? assignedTo : memberProfiles[0]

    const matchingProductIds = products
      .map(p => p.sfid)
      .filter(sfid => {
        const alreadyDiscounted = discountedProducts.some(p => p.productKey === sfid)
        if (alreadyDiscounted) {
          return false
        }
        return true
      })

    matchingProductIds.forEach(sfid => {
      let matchingProducts = registeredProducts.filter(p => p.productKey === sfid)

      if (type === 'unique' && matchingMemberProfile) {
        matchingProducts = matchingProducts.filter(p => p.memberProfile === matchingMemberProfile)
      }

      const matchingProductCount = matchingProducts.length

      if (matchingProductCount === 0) {
        return
      }

      const totalProductQty = matchingProducts.reduce((acc, product) => {
        const { quantity = 0 } = product
        acc += quantity
        return acc
      }, 0)

      let discountAmount = 0
      if (discountBy.toLowerCase() === 'amount') {
        discountAmount = amount > 0 && totalProductQty > 0 ? amount / totalProductQty : 0
      }

      matchingProducts.forEach(product => {
        const { price = 0 } = product

        discountedProducts.push({
          ...product,
          promoCodeId: codeId,
          promoCodeRule: {
            id: ruleId,
            name,
          },
          promoCodeDiscount: {
            discountBy,
            ...(discountBy.toLowerCase() === 'amount'
              ? {
                  amount: discountAmount <= price ? discountAmount : price,
                }
              : {}),
            ...(discountBy.toLowerCase() === 'percentage' ? { percentage } : {}),
          },
        })
      })
    })
  })

  const calculateProductPromoCode = (registrationKey, productKey, productTotalPrice = 0) => {
    const product = discountedProducts.find(p => p.registrationKey === registrationKey && p.productKey === productKey)

    if (!product) {
      return null
    }

    const { promoCodeDiscount, quantity = 1 } = product
    const { discountBy, amount, percentage } = promoCodeDiscount

    let promoCodeAmount = 0
    switch (discountBy?.toLowerCase()) {
      case 'amount':
        promoCodeAmount = amount * quantity
        break
      case 'percentage':
        promoCodeAmount = percentage > 0 ? (percentage / 100) * productTotalPrice : 0
        break
    }

    if (promoCodeAmount > productTotalPrice) {
      promoCodeAmount = productTotalPrice
    }

    return {
      ...product,
      promoCodeAmount,
    }
  }

  return {
    discountedProducts,
    calculateProductPromoCode,
  }
}

function processFormData(formData) {
  const {
    registrations,
    productList,
    registeredTeam,
    isTeamRego,
    organisation: { sfid: orgId },
  } = formData

  let registeredProducts = []

  if (isTeamRego) {
    const acc = []
    const { teamProducts, teamSubEventProducts, teamAddOn } = registeredTeam || {}

    const allProducts = {
      ...teamProducts,
      ...teamSubEventProducts,
      ...teamAddOn,
    }

    Object.keys(allProducts).forEach(productKey => {
      const product = allProducts[productKey]
      const { checked, quantity: productQuantity } = product || {}

      if (!checked) {
        return
      }

      const productData = productList.find(p => p.sfid === productKey)
      const { id, name, type, price: productPrice, definedById } = productData || {}

      const price = productPrice ? Number(productPrice) : 0
      const quantity = productPrice ? Number(productQuantity) : 0

      const totalPrice = quantity * price

      if (checked && definedById === orgId) {
        acc.push({
          id,
          productKey,
          registrationKey: 'teamRegistration',
          name,
          type,
          // biome-ignore lint/suspicious/noGlobalIsNan: TODO
          price: !isNaN(price) ? price : 0,
          // biome-ignore lint/suspicious/noGlobalIsNan: TODO
          quantity: !isNaN(quantity) ? quantity : 0,
          // biome-ignore lint/suspicious/noGlobalIsNan: TODO
          totalPrice: !isNaN(totalPrice) ? totalPrice : 0,
        })
      }
    })
    registeredProducts = acc
  } else {
    registeredProducts = Object.keys(registrations).reduce((acc, registrationKey) => {
      const registration = registrations[registrationKey]
      const { newProducts, newSubEventProducts, newAddOnProducts, relatedMemberProfileId } = registration || {}

      const allProducts = {
        ...newProducts,
        ...newSubEventProducts,
        ...newAddOnProducts,
      }

      Object.keys(allProducts).forEach(productKey => {
        const product = allProducts[productKey]
        const { checked, quantity: productQuantity } = product || {}

        if (!checked) {
          return
        }

        const productData = productList.find(p => p.sfid === productKey)
        const { id, name, type, price: productPrice } = productData || {}

        const price = productPrice ? Number(productPrice) : 0
        const quantity = productPrice ? Number(productQuantity) : 0

        const totalPrice = quantity * price

        if (checked) {
          acc.push({
            id,
            registrationKey,
            productKey,
            name,
            type,
            // biome-ignore lint/suspicious/noGlobalIsNan: TODO
            price: !isNaN(price) ? price : 0,
            // biome-ignore lint/suspicious/noGlobalIsNan: TODO
            quantity: !isNaN(quantity) ? quantity : 0,
            // biome-ignore lint/suspicious/noGlobalIsNan: TODO
            totalPrice: !isNaN(totalPrice) ? totalPrice : 0,
            memberProfile: relatedMemberProfileId,
          })
        }
      })

      return acc
    }, [])
  }

  return registeredProducts
}
